import * as api from '../linksApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import { DeleteLink, linkActionCreators, LinkActionKeys } from '..';
import { uiActionCreators } from '../../ui';

function* deleteLinkSaga(action: DeleteLink) {
  yield put(uiActionCreators.showSpinnerDialog());
  yield call(api.deleteLink, action.payload.linkId);

  yield put(linkActionCreators.deleteLinkFulfilled(action.payload.linkId));
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteLink() {
  yield takeEvery(LinkActionKeys.DETELTE_LINK, deleteLinkSaga);
}
